<template>
    <div>                
        <div class="page-header-image">
            <div class="grid-container" style="background-image: linear-gradient(to right, #6190e8, #739ce9, #84a8e9, #95b3e8, #a7bfe8);">                    
                <div class="grid-child compopo-small-logo-header"> 
                    <img src="img/compologo.png" alt=logo>         
                    <h3 class="title">Comparing worldwide eBay stores</h3>
                </div>
                <div class="grid-child search-bar">
                    <div ref="searchBar">            
                        <vue-autosuggest 
                            v-on:keyup.enter="onEnter"
                            :suggestions="suggestions"
                            :input-props="{id:'autosuggest__input', placeholder:'What would you like to buy?', type:'search'}"
                            @input="onInputChange"
                            @selected="onSelected"
                            @click="clickHandler"
                        >              
                            <template slot-scope="{suggestion}">
                                <span class="my-suggestion-item">{{suggestion.item}}</span>
                            </template>
                        </vue-autosuggest>
                    </div> 
                </div>                       
                <div class="grid-child search-button">
                    <n-button @click="clicked" class="btn-search" round>
                    <i class="now-ui-icons ui-1_zoom-bold"></i>
                    </n-button>
                </div>            
            </div>
        </div>        
        <scrollable-categories></scrollable-categories>
    </div> 
</template>


<script>

import { VueAutosuggest } from 'vue-autosuggest';
import ScrollableCategories from './components/ScrollableCategories.vue';
import { Button } from '@/components';

export default {
    
    components: {
        VueAutosuggest,
        ScrollableCategories,
        [Button.name]: Button
    },
    
    data() {
        return {
            suggestions: ["a", "b", "c"]
        }
    },

    methods: {
        onEnter() {

        },

        onInputChange() {

        },

        onSelected() {

        },

        clickHandler() {

        },

        clicked() {

        }
    }
}
</script>


<style>



</style>